"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./SignIn.css");
var react_redux_1 = require("react-redux");
var DeAuthentication = require("../store/DeAuthentication");
var react_router_1 = require("react-router");
var reactstrap_1 = require("reactstrap");
var SignOut = /** @class */ (function (_super) {
    __extends(SignOut, _super);
    function SignOut(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            success: false,
            isHideAlert: false
        };
        return _this;
    }
    SignOut.prototype.componentWillMount = function () {
        this.props.deleteAuthentication();
    };
    SignOut.prototype.render = function () {
        if (this.props.isLoading) {
            return (React.createElement("ul", null,
                React.createElement(reactstrap_1.Spinner, { color: "primary", style: { width: '2rem', height: '2rem', marginTop: '2rem' } }),
                ' '));
        }
        else {
            return (React.createElement(react_router_1.Redirect, { to: "/login" }));
        }
    };
    return SignOut;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.deAuthentication; }, DeAuthentication.actionCreators)(SignOut);
//# sourceMappingURL=SignOut.js.map